import request from '@/utils/request'

export function getstudylist(data) { // 研习社列表
  return request({
      url: '/backend/activity/page/list',
      method: 'post',
      data: data
  })
}

export function getstudyinfo(data) { // 获取详情
  return request({
      url: '/backend/activity/page/info',
      method: 'post',
      data: data
  })
}

export function updatestudyinfo(data) { // 编辑详情
  return request({
      url: '/backend/activity/page/update',
      method: 'post',
      data: data
  })
}

export function getconsumerlist(data) { // 用户列表
  return request({
      url: '/backend/activity/page/consumer/list',
      method: 'post',
      data: data
  })
}

export function updateconsumerinfo(data) { // 编辑用户备注
  return request({
      url: '/backend/activity/page/consumer/update',
      method: 'post',
      data: data
  })
}

export function delteconsumerinfo(data) { // 编辑用户备注
  return request({
      url: '/backend/activity/page/consumer/del',
      method: 'post',
      data: data
  })
}
